import Markdown from 'react-markdown';

import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize, {
  type Options as SanitizeSchema,
} from 'rehype-sanitize';

import { ListItem } from './ListItem.jsx';
import { OrderedList } from './OrderedList.jsx';
import { Paragraph } from './Paragraph.jsx';
import { UnorderedList } from './UnorderedList.jsx';
import './Markdown.css';

const userMessageSanitizeSchema: SanitizeSchema = {
  tagNames: [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'p',
    'br',
    'hr',
    'ul',
    'ol',
    'li',
    'blockquote',
    'a',
    'em',
    'strong',
    'b',
    'i',
    'u',
    'del',
    's',
    'code',
    'pre',
  ],
  attributes: {
    a: ['href'],
    code: [['className', /^language-./]],
  },
  protocols: {
    href: ['http', 'https', 'mailto'],
  },
  ancestors: {},
  required: {},
  clobber: [],
  strip: ['script', 'style'],
  allowComments: false,
  allowDoctypes: false,
};

const MarkdownTextUser = ({ text }: { text: string }) => {
  return (
    <Markdown
      components={{
        p: Paragraph,
        ul: UnorderedList,
        ol: OrderedList,
        li: ListItem,
      }}
      rehypePlugins={[rehypeRaw, [rehypeSanitize, userMessageSanitizeSchema]]}
    >
      {text}
    </Markdown>
  );
};

const MarkdownTextAi = ({
  text,
  className,
  id,
}: {
  text: string;
  className?: string;
  id?: string;
}) => {
  return (
    <div
      className={cn(
        'markdown-content',
        typographyVariants({ variant: 'bodyLong01' }),
        className,
      )}
      data-testid={id}
    >
      <Markdown>{text}</Markdown>
    </div>
  );
};

export { MarkdownTextUser, MarkdownTextAi };
